import Grid from "@mui/material/Grid";
import * as React from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import TelegramIcon from "@mui/icons-material/Telegram";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

import MoreVertIcon from "@mui/icons-material/MoreVert";

import { Dialog, ListItemText, Menu, MenuItem } from "@mui/material";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";

// import IconButton from '@mui/material/IconButton';

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { useEffect } from "react";
import { useState } from "react";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";
import { postUnLike } from "services/apiService";
import { postLike } from "services/apiService";
import { postComment } from "services/apiService";
import LikesDialog from "layouts/dialogModals/LikesDialog";
import CommentsDialog from "layouts/dialogModals/CommentDialog";
import { getAccountPost } from "services/apiService";
import nftSvg from "assets/images/NFT.svg";
import MDButton from "components/MDButton";
import MintDialog from "layouts/dialogModals/mintDialog";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { getListNftUser } from "services/apiService";
import { getUserInfo } from "services/apiService";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { auctionCancel } from "services/apiService";
import InfiniteScroll from "react-infinite-scroll-component";
import Moment from "react-moment";
import { removeNftAuction } from "services/contractService";
import { getPostById } from "services/apiService";
import { useRef } from "react";
import { getNftById } from "services/apiService";

import nftWhite from "assets/images/nftWhite.png";
import SpinLoader from "components/SpinLoader";
import FeedLoader from "components/SkeletonLoader/feedLoader";
import { postDelete } from "services/apiService";
import ShareDialog from "layouts/dialogModals/ShareDialog";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useMediaQuery } from "react-responsive";
import ReportDialog from "layouts/dialogModals/ReportDialog";
import { reportUser } from "services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { profilePostReducerPlus } from "Store/slices/profileDataSlice";
import { profileNftReducerPlus } from "Store/slices/profileDataSlice";
import { profilePostReducer } from "Store/slices/profileDataSlice";
import { profileNftReducer } from "Store/slices/profileDataSlice";
import { profileDataReducer } from "Store/slices/profileDataSlice";
import { profileLikeUnLikeCommentReducer } from "Store/slices/profileDataSlice";
import { profileNftLikeUnLikeCommentReducer } from "Store/slices/profileDataSlice";
import { web3Instance } from "Store/slices/walletSlice";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

function ProfilePostDetails() {
  const web3 = web3Instance();
  let navigate = useNavigate();
  let location = useLocation();
  const dispatch = useDispatch();

  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);

  const { isWeb3Enabled, address, chainId, balance, reward, isWalletLoading } =
    useSelector((state) => state.walletData);

  const {
    profileData,
    profilePost,
    profilePostPageNumber,
    profilePostCount,
    profileNft,
    profileNftPageNumber,
    profileNftCount,
    isLoadingProfile,
  } = useSelector((state) => state.profileData);

  const [searchParams] = useSearchParams();
  const { sales, tasks } = reportsLineChartData;

  const [post, setPost] = useState([]);
  const [comment, setComment] = useState("");
  const [postId, setPostId] = useState("");
  const [likeDialogBoolean, setLikeDialogBoolean] = useState(false);
  const [commentDialogBoolean, setCommentDialogBoolean] = useState(false);
  const [mintDialogBoolean, setMintDialogBoolean] = useState(false);
  const [mintNftData, setMintNftData] = useState("");
  const [changePriceBoolean, setChangePriceBoolean] = useState(false);
  const [postPageNumber, setPostPageNumber] = useState(1);
  const [nftPageNumber, setNftPageNumber] = useState(0);
  const [postCount, setPostCount] = useState(0);
  const [nftCount, setNftCount] = useState(0);
  const [commentState, setCommentState] = useState(false);
  const [likeState, setLikeState] = useState(false);
  const [mainLoader, setMainLoader] = useState(false);
  const [shareDialogBoolean, setShareDialogBoolean] = useState(false);
  const [reportDialogBoolean, setReportDialogBoolean] = useState(false);
  const [type, setType] = useState("");
  const videoRef = useRef(null);

  const [refresher, setRefresher] = useState(false);

  const [userInfo, setUserInfo] = useState("");
  const [accountInfo, setAccountInfo] = useState("");
  const postElementRef = useRef(null);

  const [secondary, setSecondary] = React.useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [elem, setElem] = useState("");

  useEffect(() => {
    if (isLoadingProfile) {
      fetchProfileData();
    } else {
      autoScroller();
    }

    // autoScroller();
  }, [elem]);

  const autoScroller = () => {
    if (searchParams.get("type") === "post") {
      setElem(document.getElementById(searchParams.get("postId")));
      // console.log("elem", elem);
      if (elem) {
        elem.scrollIntoView({
          behavior: "instant",
          block: "start",
        });
      }
    } else if (searchParams.get("type") === "nft") {
      setElem(document.getElementById(searchParams.get("nftId")));
      // console.log("elem", elem);
      if (elem) {
        elem.scrollIntoView({
          behavior: "instant",
          block: "start",
        });
      }
    }
  };

  const fetchProfileData = async () => {
    setMainLoader(true);
    const getProfileData = await getUserInfo(searchParams.get("username"));

    // console.log("getProfileData", getProfileData);

    if (getProfileData.status === 200) {
      dispatch(profileDataReducer(getProfileData.data));
    }

    const profilePostRes = await getAccountPost(
      searchParams.get("username"),
      1
    );
    // console.log("profilePostRes", profilePostRes);
    if (profilePostRes.status === 200) {
      dispatch(profilePostReducer(profilePostRes.data));
    }

    const profileNftRes = await getListNftUser(getProfileData.data.email, 0);
    // console.log("profileNftRes", profileNftRes);
    if (profilePostRes.status === 200) {
      dispatch(profileNftReducer(profileNftRes.data));
    }

    setMainLoader(false);
  };

  const fetchMorePost = async (number) => {
    // console.log("pageNumberINSIDE1", postPageNumber);

    const getAccountFeedResNew = await getAccountPost(
      searchParams.get("username"),
      number
    );
    console.log("getAccountFeedResNew", getAccountFeedResNew);

    if (getAccountFeedResNew.status === 200) {
      dispatch(profilePostReducerPlus(getAccountFeedResNew.data));
    }

    // setPost(post.concat(getAccountFeedResNew));

    // // console.log("pageNumberINSIDE2", postPageNumber);
    // setPostPageNumber((prev) => prev + 1);
  };

  const fetchMoreNft = async (number) => {
    // console.log("pageNumberINSIDE1", nftPageNumber);

    const profileNftResNew = await getListNftUser(profileData.email, number);

    if (profileNftResNew.status === 200) {
      dispatch(profileNftReducerPlus(profileNftResNew.data));
    }
    // console.log("profilePostResNew", profileNftResNew);
    // setPost(post.concat(profileNftResNew));

    // console.log("pageNumberINSIDE2", nftPageNumber);
    // setNftPageNumber((prev) => prev + 1);
  };

  const handleUsernameClick = (username) => {
    navigate(`/profile/?username=${username}`);
  };

  const handleLikeUnLike = async (type, isLikedBoolean, postId, nftId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    const postID = {
      postID: postId,
    };

    // console.log("postId", postId);
    // console.log("nftId", nftId);

    if (isLikedBoolean) {
      const postUnlikeRes = await postUnLike(postID);
      // console.log("postUnLikeRes", postUnlikeRes);

      if (type === "Post") {
        const postByIdRes = await getPostById(postId);
        // console.log("postByid", postByIdRes);

        dispatch(profileLikeUnLikeCommentReducer(postByIdRes[0]));

        // const replacePostById = (post, postByIdRes) => {
        //   return post.map((item) => {
        //     if (item._id === postByIdRes[0]._id) {
        //       return postByIdRes[0];
        //     }
        //     return item;
        //   });
        // };

        // const updatedPost = replacePostById(post, postByIdRes);
        // setPost(updatedPost);
      } else {
        const nftByIdRes = await getNftById(nftId);
        // console.log("nftByIdRes", nftByIdRes);

        dispatch(profileNftLikeUnLikeCommentReducer(nftByIdRes[0]));

        // const replaceNftById = (post, nftByIdRes) => {
        //   return post.map((item) => {
        //     if (item._id === nftByIdRes[0]._id) {
        //       return nftByIdRes[0];
        //     }
        //     return item;
        //   });
        // };

        // const updatedNft = replaceNftById(post, nftByIdRes);
        // setPost(updatedNft);
      }
    } else {
      const postLikeRes = await postLike(postID);
      // console.log("postLikeRes", postLikeRes);

      if (type === "Post") {
        const postByIdRes = await getPostById(postId);
        // console.log("postByid", postByIdRes);

        dispatch(profileLikeUnLikeCommentReducer(postByIdRes[0]));

        // const replacePostById = (post, postByIdRes) => {
        //   return post.map((item) => {
        //     if (item._id === postByIdRes[0]._id) {
        //       return postByIdRes[0];
        //     }
        //     return item;
        //   });
        // };

        // const updatedPost = replacePostById(post, postByIdRes);
        // setPost(updatedPost);
      } else {
        const nftByIdRes = await getNftById(nftId);
        // console.log("nftByIdRes", nftByIdRes);

        dispatch(profileNftLikeUnLikeCommentReducer(nftByIdRes[0]));

        // const replaceNftById = (post, nftByIdRes) => {
        //   return post.map((item) => {
        //     if (item._id === nftByIdRes[0]._id) {
        //       return nftByIdRes[0];
        //     }
        //     return item;
        //   });
        // };

        // const updatedNft = replaceNftById(post, nftByIdRes);
        // setPost(updatedNft);
      }
    }
  };

  const handleInputChange = (value, postId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setComment({
      // ...comment,
      [postId]: value,
    });
  };

  const handlePostComment = async (type, postId, nftId) => {
    const postComData = {
      comment: comment[postId],
      postID: postId,
    };

    const postComRes = await postComment(postComData);
    // console.log("postComRes", postComRes);
    setComment("");

    if (type === "Post") {
      const postByIdRes = await getPostById(postId);
      // console.log("postByid", postByIdRes);
      dispatch(profileLikeUnLikeCommentReducer(postByIdRes[0]));
      // const replacePostById = (post, postByIdRes) => {
      //   return post.map((item) => {
      //     if (item._id === postByIdRes[0]._id) {
      //       return postByIdRes[0];
      //     }
      //     return item;
      //   });
      // };

      // const updatedPost = replacePostById(post, postByIdRes);
      // setPost(updatedPost);
    } else {
      const nftByIdRes = await getNftById(nftId);
      // console.log("nftByIdRes", nftByIdRes);

      dispatch(profileNftLikeUnLikeCommentReducer(nftByIdRes[0]));

      // const replaceNftById = (post, nftByIdRes) => {
      //   return post.map((item) => {
      //     if (item._id === nftByIdRes[0]._id) {
      //       return nftByIdRes[0];
      //     }
      //     return item;
      //   });
      // };

      // const updatedNft = replaceNftById(post, nftByIdRes);
      // setPost(updatedNft);
    }

    // const postByIdRes = await getPostById(postId);
    // console.log("postByid", postByIdRes);

    // const replacePostById = (post, postByIdRes) => {
    //   return post.map((item) => {
    //     if (item._id === postByIdRes[0]._id) {
    //       return postByIdRes[0];
    //     }
    //     return item;
    //   });
    // };

    // const updatedPost = replacePostById(post, postByIdRes);
    // setPost(updatedPost);
  };

  const openLikesDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(value);
    setLikeDialogBoolean(true);
  };

  const handleCloseLikeDialog = () => {
    setLikeDialogBoolean(false);
  };

  const openCommentsDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(value);
    setCommentDialogBoolean(true);
  };

  const handleCloseCommentDialog = () => {
    setCommentDialogBoolean(false);
  };

  const handleOpenMintDialog = (value, priceChangeBoolean) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (!isWeb3Enabled) {
      // console.log("pls connect wallet");
      // Swal.fire("", "Please connect your Metamask Wallet");
      toast.warning(`Please connect your Metamask Wallet`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }
    setMintNftData(value);
    setChangePriceBoolean(priceChangeBoolean);
    setMintDialogBoolean(true);
  };

  const handleCloseMintDialog = () => {
    setMintDialogBoolean(false);
  };

  const handleVideoClick = (item) => {
    navigate(`/reels`, { state: item });
  };

  const handleRemoveAuction = async (uselessState, auctionId, tokenId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (!isWeb3Enabled) {
      toast.warning(`Please connect your Metamask Wallet`, {
        style: {
          fontSize: "12px",
        },
      });
      return;
    }
    // console.log("fire", auctionId);
    Swal.fire({
      title: "Remove From Auction?",
      text: "Are you sure you want to remove this nft from auction?",
      // icon: "warning",
      background: "darkgray",
      width: "360px",
      confirmButtonText: "Remove",
      confirmButtonColor: "red",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        removeNftAuction(web3, address, tokenId).then((res) => {
          // console.log("res", res);

          if (res.transactionHash) {
            auctionCancel(auctionId).then((res) => {
              // console.log("res", res);
              toast.success(`Auction removed`, {
                style: {
                  fontSize: "15px",
                },
              });
              navigate("/nft-marketplace/?status=Not for sale");
            });
          } else {
            toast.error(`Contract failed, please try again later`, {
              style: {
                fontSize: "15px",
              },
            });
          }
        });
      }
    });
  };

  const handleShare = (type, postId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setType(type);
    setPostId(postId);
    setShareDialogBoolean(true);
  };

  const handleCloseShareDialog = () => {
    setShareDialogBoolean(false);
  };

  const handleOpenDelete = async (uselessState, postId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    const deleteData = {
      postID: postId,
    };

    // const postDeleteRes = await postDelete(deleteData);

    // console.log("REs", postDeleteRes);

    Swal.fire({
      title: "Delete this post?",
      text: "Are you sure you want to delete this post?",
      icon: "warning",
      background: "darkgray",
      width: "360px",
      confirmButtonText: "Delete",
      confirmButtonColor: "red",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        postDelete(deleteData).then((deleteRes) => {
          // console.log("res", deleteRes);
          if (deleteRes.status === 200) {
            toast.success(`Post Deleted`, {
              style: {
                fontSize: "15px",
              },
            });
            setRefresher((prev) => !prev);
          } else {
            toast.error(`Something went wrong, please try again`, {
              style: {
                fontSize: "15px",
              },
            });
          }
        });
      }
    });
  };

  const handleReport = async (uselessState, reportType, reportIdentifier) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (reportType === "post") {
      setPostId(reportIdentifier);
      setReportDialogBoolean(true);
    } else {
      const reportUserRes = await reportUser(reportIdentifier);
      // console.log("reportUserRes", reportUserRes);

      if (reportUserRes.status === 200) {
        Swal.fire({
          title: "Thank you reporting",
          text: "We will review and take the necessary action against this.",
          icon: "success",
          background: "darkgray",
          width: "360px",
          // confirmButtonText: "Remove",
          // confirmButtonColor: "red",
          // showCancelButton: true,
        });
      } else {
        toast.error(`Something went wrong, Please try again`, {
          style: {
            fontSize: "15px",
          },
        });
      }
    }
  };

  const handleCloseReportDialog = () => {
    setReportDialogBoolean(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox mt={4.5}>
        <Grid container justifyContent="space-between">
          <Grid
            item
            xs={12}
            // md={5.5}
            lg={5.5}
            sx={{ marginLeft: isTabletOrMobile ? null : 13 }}
          >
            {searchParams.get("type") === "post" ? (
              <>
                <InfiniteScroll
                  dataLength={profilePost.length}
                  next={() => fetchMorePost(profilePostPageNumber + 1)}
                  hasMore={profilePost.length < profilePostCount}
                  loader={
                    <MDBox sx={{ textAlign: "center" }}>
                      <SpinLoader />
                    </MDBox>
                  }
                >
                  {mainLoader ? (
                    <FeedLoader />
                  ) : (
                    profilePost.length > 0 &&
                    profilePost.map((item, idx) => (
                      <MDBox mb={3} key={idx} id={item._id}>
                        <Card sx={{}}>
                          <CardHeader
                            sx={{ padding: "10px" }}
                            avatar={
                              <MDAvatar
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleUsernameClick(item.username)
                                }
                                imgProps={{
                                  style: { height: "100%", width: "100%" },
                                }}
                                src={item.pic}
                              />
                            }
                            action={
                              localStorage.userNameSingh === item.username ? (
                                item.nftStatus === "false" && (
                                  <PopupState
                                    variant="popover"
                                    popupId="demo-popup-menu"
                                  >
                                    {(popupState) => (
                                      <>
                                        <IconButton
                                          {...bindTrigger(popupState)}
                                        >
                                          <MoreVertIcon
                                            sx={{ color: "#fff" }}
                                          />
                                        </IconButton>
                                        <Menu {...bindMenu(popupState)}>
                                          <MenuItem
                                            onClick={() =>
                                              handleOpenDelete(
                                                popupState.close(),
                                                item._id
                                              )
                                            }
                                          >
                                            Delete post
                                          </MenuItem>
                                        </Menu>
                                      </>
                                    )}
                                  </PopupState>
                                )
                              ) : (
                                <PopupState
                                  variant="popover"
                                  popupId="demo-popup-menu"
                                >
                                  {(popupState) => (
                                    <>
                                      <IconButton {...bindTrigger(popupState)}>
                                        <MoreVertIcon sx={{ color: "#fff" }} />
                                      </IconButton>
                                      <Menu {...bindMenu(popupState)}>
                                        <MenuItem
                                          onClick={() =>
                                            handleReport(
                                              popupState.close(),
                                              "post",
                                              item._id
                                            )
                                          }
                                        >
                                          Report
                                        </MenuItem>
                                        <MenuItem
                                          onClick={() =>
                                            handleReport(
                                              popupState.close(),
                                              "account",
                                              item.username
                                            )
                                          }
                                        >
                                          Report Account
                                        </MenuItem>
                                      </Menu>
                                    </>
                                  )}
                                </PopupState>
                              )
                            }
                            title={
                              <MDTypography
                                fontWeight="bold"
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleUsernameClick(item.username)
                                }
                              >
                                {item.username}
                              </MDTypography>
                            }
                          />
                          <MDBox sx={{ height: "400px" }}>
                            {item.postType === "video" ? (
                              <>
                                <video
                                  onClick={() => handleVideoClick(item)}
                                  height="100%"
                                  width="100%"
                                  style={{
                                    cursor: "pointer",
                                    position: "relative",
                                  }}
                                >
                                  <source src={item.photo} type="video/mp4" />
                                </video>
                                <MDTypography
                                  fontSize="50px"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => handleVideoClick(item)}
                                >
                                  <PlayCircleOutlineIcon
                                    sx={{
                                      position: "absolute",
                                      top: "40%",
                                      right: "47%",
                                    }}
                                  />
                                </MDTypography>
                              </>
                            ) : (
                              <img
                                // style={{ objectFit: "cover" }}
                                src={item.photo}
                                height="100%"
                                width="100%"
                                alt="image"
                              />
                            )}
                          </MDBox>

                          <CardActions
                            disableSpacing
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <MDBox sx={{ display: "flex" }}>
                              <MDBox
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <IconButton
                                  aria-label="add to favorites"
                                  onClick={() =>
                                    handleLikeUnLike(
                                      "Post",
                                      item.isLiked,
                                      item._id
                                    )
                                  }
                                >
                                  {item.isLiked ? (
                                    <FavoriteIcon style={{ color: "red" }} />
                                  ) : (
                                    <FavoriteBorderIcon
                                      style={{ color: "#fff" }}
                                    />
                                  )}
                                </IconButton>
                                <MDTypography
                                  fontWeight="bold"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => openLikesDialog(item._id)}
                                >
                                  {item.totalLike}
                                </MDTypography>
                              </MDBox>

                              <MDBox
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <IconButton
                                  aria-label="add to favorites"
                                  onClick={() => openCommentsDialog(item._id)}
                                >
                                  <ChatBubbleOutlineIcon
                                    style={{ color: "#fff" }}
                                  />
                                </IconButton>
                                <MDTypography
                                  fontWeight="bold"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => openCommentsDialog(item._id)}
                                >
                                  {item.totalComment}
                                </MDTypography>
                              </MDBox>
                              <MDBox
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <IconButton
                                  onClick={() => handleShare("post", item._id)}
                                >
                                  <TelegramIcon style={{ color: "#fff" }} />
                                </IconButton>
                              </MDBox>
                            </MDBox>
                            {localStorage.userNameSingh ===
                              searchParams.get("username") && (
                              <MDBox>
                                {item.nftStatus === "true" ? (
                                  <MDAvatar src={nftSvg} />
                                ) : item.postType != "video" ? (
                                  <MDButton
                                    sx={{ borderRadius: "20px" }}
                                    color="singh"
                                    size="small"
                                    startIcon={
                                      <MDAvatar
                                        src={nftWhite}
                                        size="xs"
                                        imgProps={{
                                          style: {
                                            height: "100%",
                                            width: "100%",
                                          },
                                        }}
                                      />
                                    }
                                    onClick={() => handleOpenMintDialog(item)}
                                  >
                                    <MDTypography fontSize="15px">
                                      Mint NFT
                                    </MDTypography>
                                  </MDButton>
                                ) : (
                                  <></>
                                )}
                              </MDBox>
                            )}
                          </CardActions>
                          <CardContent
                            sx={{
                              paddingTop: 0,
                              paddingBottom: 0,
                              paddingLeft: 2.5,
                              paddingRight: 2.5,
                              marginBottom: "0.5rem",
                            }}
                          >
                            <MDTypography
                              fontWeight="bold"
                              whiteSpace="pre-wrap"
                              sx={{ fontSize: "15px" }}
                            >
                              {item.caption}
                            </MDTypography>
                            <MDTypography
                              sx={{ color: "grey", fontSize: "15px" }}
                            >
                              <Moment fromNow>{item.updatedTime}</Moment>
                            </MDTypography>
                          </CardContent>
                          <MDBox
                            sx={{
                              p: "2px 4px",
                              display: "flex",
                              alignItems: "center",
                              borderTop: "0.5px solid #333333",
                            }}
                          >
                            <IconButton sx={{ p: "5px" }}>
                              <MDAvatar
                                src={userAppInfo?.profilePic}
                                sx={{
                                  cursor: "pointer",
                                  width: "2rem",
                                  height: "2rem",
                                }}
                                imgProps={{
                                  style: { height: "100%", width: "100%" },
                                }}
                              />
                            </IconButton>
                            <InputBase
                              sx={{
                                ml: 1,
                                flex: 1,
                                fontSize: "18px",
                              }}
                              multiline
                              placeholder="Add a comment..."
                              inputProps={{ style: { color: "#6a6a6a" } }}
                              value={comment[item._id] || ""}
                              onChange={(e) =>
                                handleInputChange(e.target.value, item._id)
                              }
                            />

                            <IconButton
                              disabled={
                                comment === "" || !/\S/.test(comment[item._id])
                              }
                              sx={{}}
                              onClick={() =>
                                handlePostComment("Post", item._id)
                              }
                            >
                              <MDTypography
                                sx={{
                                  color:
                                    comment === "" ||
                                    !/\S/.test(comment[item._id])
                                      ? "grey"
                                      : "",
                                  fontSize: "18px",
                                }}
                              >
                                Post
                              </MDTypography>
                            </IconButton>
                          </MDBox>
                        </Card>
                      </MDBox>
                    ))
                  )}
                </InfiniteScroll>
              </>
            ) : (
              <>
                <InfiniteScroll
                  dataLength={profileNft.length}
                  next={() => fetchMoreNft(profileNftPageNumber + 1)}
                  hasMore={profileNft.length < profileNftCount}
                  loader={
                    <MDBox sx={{ textAlign: "center" }}>
                      <SpinLoader />
                    </MDBox>
                  }
                >
                  {mainLoader ? (
                    <FeedLoader />
                  ) : (
                    profileNft.length > 0 &&
                    profileNft.map((item, idx) => (
                      <MDBox mb={3} key={idx} id={item._id}>
                        <Card sx={{}}>
                          <CardHeader
                            avatar={
                              <MDAvatar
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleUsernameClick(item.userDetails.username)
                                }
                                imgProps={{
                                  style: { height: "100%", width: "100%" },
                                }}
                                src={item.userDetails.pic}
                              />
                            }
                            action={
                              localStorage.userNameSingh ===
                                searchParams.get("username") && (
                                <PopupState
                                  variant="popover"
                                  popupId="demo-popup-menu"
                                >
                                  {(popupState) => (
                                    <>
                                      <IconButton {...bindTrigger(popupState)}>
                                        <MoreVertIcon sx={{ color: "#fff" }} />
                                      </IconButton>
                                      <Menu {...bindMenu(popupState)}>
                                        {item.sellingStatus ===
                                          "Not for sale" && (
                                          <MenuItem
                                            onClick={() =>
                                              handleOpenMintDialog(item, false)
                                            }
                                          >
                                            Set for auction
                                          </MenuItem>
                                        )}

                                        {item.sellingStatus === "For sale" && (
                                          <MenuItem
                                            onClick={() =>
                                              handleOpenMintDialog(item, true)
                                            }
                                          >
                                            Change price
                                          </MenuItem>
                                        )}

                                        {item.sellingStatus !==
                                          "Not for sale" && (
                                          <MenuItem
                                            onClick={() =>
                                              handleRemoveAuction(
                                                popupState.close(),
                                                item._id,
                                                item.tokenID
                                              )
                                            }
                                          >
                                            Remove from auction
                                          </MenuItem>
                                        )}
                                      </Menu>
                                    </>
                                  )}
                                </PopupState>
                              )
                            }
                            title={
                              <MDTypography
                                fontWeight="bold"
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleUsernameClick(item.userDetails.username)
                                }
                              >
                                {item.userDetails.username}
                              </MDTypography>
                            }
                            // subheader="September 14, 2016"
                          />
                          <MDBox
                            //  onClick={handleVideo}
                            sx={{ height: "400px" }}
                          >
                            {item.postType === "video" ? (
                              <video
                                ref={videoRef}
                                height="100%"
                                width="100%"
                                // src={item.photo}
                                // autoPlay
                                loop
                                // muted
                                controls
                              >
                                <source
                                  src={item.postDetails.photo}
                                  type="video/mp4"
                                />
                              </video>
                            ) : (
                              <img
                                // style={{ objectFit: "cover" }}
                                src={item.postDetails.photo}
                                height="100%"
                                width="100%"
                                alt="image"
                              />
                            )}
                          </MDBox>

                          <CardActions
                            disableSpacing
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <MDBox sx={{ display: "flex" }}>
                              <MDBox
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <IconButton
                                  aria-label="add to favorites"
                                  onClick={() =>
                                    handleLikeUnLike(
                                      "Nft",
                                      item.postDetails.isLiked,
                                      item.postDetails._id,
                                      item._id
                                    )
                                  }
                                >
                                  {item.postDetails.isLiked ? (
                                    <FavoriteIcon style={{ color: "red" }} />
                                  ) : (
                                    <FavoriteBorderIcon
                                      style={{ color: "#fff" }}
                                    />
                                  )}
                                </IconButton>
                                <MDTypography
                                  fontWeight="bold"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() =>
                                    openLikesDialog(item.postDetails._id)
                                  }
                                >
                                  {item.postDetails.totalLike}
                                </MDTypography>
                              </MDBox>
                              <MDBox
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <IconButton
                                  onClick={() =>
                                    openCommentsDialog(item.postDetails._id)
                                  }
                                  aria-label="add to favorites"
                                >
                                  <ChatBubbleOutlineIcon
                                    style={{ color: "#fff" }}
                                  />
                                </IconButton>
                                <MDTypography
                                  fontWeight="bold"
                                  sx={{ cursor: "pointer" }}
                                  onClick={() =>
                                    openCommentsDialog(item.postDetails._id)
                                  }
                                >
                                  {item.postDetails.totalComment}
                                </MDTypography>
                              </MDBox>
                              <MDBox
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <IconButton
                                  onClick={() => handleShare("nft", item._id)}
                                >
                                  <TelegramIcon style={{ color: "#fff" }} />
                                </IconButton>
                              </MDBox>
                            </MDBox>
                            {localStorage.userNameSingh ===
                              searchParams.get("username") && (
                              <MDBox sx={{}}>
                                {item.postDetails.nftStatus === "true" ? (
                                  <MDButton
                                    sx={{ borderRadius: "20px" }}
                                    color="singh"
                                    size="small"
                                    startIcon={
                                      <MDAvatar
                                        src={nftWhite}
                                        // size={isTabletOrMobile ? "xs" : "sm"}
                                        size="xs"
                                        // sx={{ position: "absolute", right: "0px" }}
                                        imgProps={{
                                          style: {
                                            height: "100%",
                                            width: "100%",
                                          },
                                        }}
                                      />
                                    }
                                  >
                                    <MDTypography fontSize="15px">
                                      {item.sellingStatus === "Not for sale"
                                        ? "Owned"
                                        : "On sale"}
                                    </MDTypography>
                                  </MDButton>
                                ) : (
                                  <MDButton
                                    color="singh"
                                    onClick={() => handleOpenMintDialog(item)}
                                  >
                                    Mint NFT
                                  </MDButton>
                                )}
                              </MDBox>
                            )}
                          </CardActions>
                          <CardContent
                            sx={{
                              paddingTop: 0,
                              paddingBottom: 0,
                              paddingLeft: 2.5,
                              paddingRight: 2.5,
                              marginBottom: "0.5rem",
                            }}
                          >
                            <MDTypography
                              fontWeight="bold"
                              whiteSpace="pre-wrap"
                              sx={{ fontSize: "15px" }}
                            >
                              {item.postDetails.caption}
                            </MDTypography>
                            <MDTypography
                              sx={{ color: "grey", fontSize: "15px" }}
                            >
                              <Moment fromNow>{item.updatedTime}</Moment>
                            </MDTypography>
                          </CardContent>
                          <MDBox
                            // component="form"
                            sx={{
                              p: "2px 4px",
                              display: "flex",
                              alignItems: "center",
                              borderTop: "0.5px solid #333333",
                            }}
                          >
                            <IconButton sx={{ p: "5px" }}>
                              <MDAvatar
                                src={userAppInfo?.profilePic}
                                sx={{ cursor: "pointer" }}
                                imgProps={{
                                  style: { height: "100%", width: "100%" },
                                }}
                              />
                            </IconButton>
                            <InputBase
                              sx={{ ml: 1, flex: 1 }}
                              multiline
                              placeholder="Add a comment..."
                              inputProps={{ style: { color: "#6a6a6a" } }}
                              value={comment[item.postDetails._id] || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  e.target.value,
                                  item.postDetails._id
                                )
                              }
                            />
                            <IconButton
                              disabled={
                                comment === "" || !/\S/.test(comment[item._id])
                              }
                              sx={{}}
                              onClick={() =>
                                handlePostComment(
                                  "Nft",
                                  item.postDetails._id,
                                  item._id
                                )
                              }
                            >
                              <MDTypography
                                sx={{
                                  color:
                                    comment === "" ||
                                    !/\S/.test(comment[item._id])
                                      ? "grey"
                                      : "",
                                }}
                              >
                                Post
                              </MDTypography>
                            </IconButton>
                          </MDBox>
                        </Card>
                      </MDBox>
                    ))
                  )}
                </InfiniteScroll>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>

      {reportDialogBoolean && (
        <ReportDialog
          openStatus={reportDialogBoolean}
          onClose={() => handleCloseReportDialog()}
          postId={postId}
        />
      )}

      {shareDialogBoolean && (
        <ShareDialog
          openStatus={shareDialogBoolean}
          onClose={() => handleCloseShareDialog()}
          postId={postId}
          type={type}
        />
      )}

      {likeDialogBoolean && (
        <LikesDialog
          openStatus={likeDialogBoolean}
          onClose={() => handleCloseLikeDialog()}
          postId={postId}
        />
      )}

      {commentDialogBoolean && (
        <CommentsDialog
          openStatus={commentDialogBoolean}
          onClose={() => handleCloseCommentDialog()}
          postId={postId}
        />
      )}

      {mintDialogBoolean && (
        <MintDialog
          openStatus={mintDialogBoolean}
          onClose={() => handleCloseMintDialog()}
          mintData={mintNftData}
          priceChange={changePriceBoolean}
        />
      )}

      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default ProfilePostDetails;
